'use client';
import { useLogout } from '@/hooks/useLogout';
import { Button, LucideIcon, DynamicModal } from '@fileverse/ui';
import { useAccountContext } from './account-provider';
import { useEffect } from 'react';

const ImpossibleMigrationModal = ({
  isImpossibleToMigrate,
  setIsImpossibleToMigrate,
}: {
  isImpossibleToMigrate: boolean;
  setIsImpossibleToMigrate: (isImpossibleToMigrate: boolean) => void;
}) => {
  const { onLogout } = useLogout();
  const { walletAddress } = useAccountContext();

  // Store in localStorage when modal opens
  useEffect(() => {
    if (isImpossibleToMigrate && walletAddress) {
      localStorage.setItem(`impossible_migration_${walletAddress}`, 'true');
    }
  }, [isImpossibleToMigrate, walletAddress]);

  return (
    <DynamicModal
      disableOutsideClick
      hasCloseIcon={false}
      open={isImpossibleToMigrate}
      onOpenChange={setIsImpossibleToMigrate}
      className="md:!max-w-[23rem] !pb-0 !rounded-lg"
      contentClassName="!py-6"
      overlayClasses="backdrop-blur-lg"
      content={
        <div className="flex flex-col gap-4 justify-center items-center px-4 text-center">
          <div className="flex items-center justify-center px-[9px] py-[5px] rounded color-bg-secondary">
            <span className="text-heading-lg">‼️</span>
          </div>
          <h3 className="text-heading-sm">
            Attention: Migration could not be completed
          </h3>
          <p className="text-body-sm color-text-secondary">
            To finalise the document migration, please log in from the device
            you originally used to create your dDocs account.
            <br />
            If you’re already on your original device and the migration isn’t
            working, please reach out to us. Team Fileverse will assist asap!
          </p>
          <div className="flex flex-col gap-3 justify-center items-center">
            <Button
              className="w-full md:w-auto gap-1"
              variant="default"
              onClick={() => {
                window.open('mailto:feedback@fileverse.io', '_blank');
              }}
            >
              <LucideIcon name="Mail" size="sm" />
              Contact us
            </Button>

            <Button
              variant="ghost"
              className="w-full md:w-auto gap-1"
              onClick={() => {
                setIsImpossibleToMigrate(false);
                onLogout();
              }}
            >
              <LucideIcon name="LogOut" size="sm" />
              Logout
            </Button>
          </div>
        </div>
      }
    />
  );
};

export { ImpossibleMigrationModal };
